import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import ContactPage from "./pages/ContactPage";
import RealisationsPage from "./pages/RealisationsPage";
import EquipePage from "./pages/EquipePage";
import ExpertisePage from "./pages/ExpertisePage";
import StudiosPage from "./pages/secteurs/StudiosPage";
import HotelleriePage from "./pages/secteurs/HotelleriePage";
import TertiairePage from "./pages/secteurs/TertiairePage";
import ResidentielPage from "./pages/secteurs/ResidentielPage";
import InstallationPage from "./pages/InstallationPage";
import MaintenancePage from "./pages/MaintenancePage";
import MentionsLegalesPage from "./pages/MentionsLegalesPage";
import PolitiqueConfidentialitePage from "./pages/PolitiqueConfidentialitePage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* HomePage - standalone with its own Navigation/Footer */}
            <Route path="/" element={<HomePage />} />
            
            {/* All other pages use Layout wrapper */}
            <Route element={<Layout />}>
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/realisations" element={<RealisationsPage />} />
              <Route path="/equipe" element={<EquipePage />} />
              <Route path="/expertise" element={<ExpertisePage />} />
              <Route path="/secteurs/studios" element={<StudiosPage />} />
              <Route path="/secteurs/hotellerie" element={<HotelleriePage />} />
              <Route path="/secteurs/tertiaire" element={<TertiairePage />} />
              <Route path="/secteurs/residentiel" element={<ResidentielPage />} />
              <Route path="/installation" element={<InstallationPage />} />
              <Route path="/maintenance" element={<MaintenancePage />} />
              <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
              <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialitePage />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
        {/* Noise overlay for texture */}
        <div className="noise-overlay" aria-hidden="true" />
      </div>
    </HelmetProvider>
  );
}

export default App;
